import { render, staticRenderFns } from "./AppShortcuts.vue?vue&type=template&id=103ae49c"
import script from "./AppShortcuts.vue?vue&type=script&lang=js"
export * from "./AppShortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports